<div class="u-row-manager-container">
  @for (row of editingModel(); track $index; let idxLine = $index) {
    <div class="row-container" [class.selected-line]="selectedLine() === idxLine">
      <ng-template *ngTemplateOutlet="rowTemplate; context: { $implicit: row, index: idxLine }"> </ng-template>
      @if (state() !== 'readonly') {
        <div class="buttons-container">
          @if (row.mode === 'constantRow') {
            <u-button
              [versionNumber]="2"
              [styleType]="'outlined'"
              [stateElement]="state() === 'disabled' ? 'disabled' : 'regular'"
              (onClick)="deleteRow(idxLine)"
              [label]="'Delete'"
            ></u-button>
            <u-button
              [versionNumber]="2"
              [styleType]="'outlined'"
              [stateElement]="state() === 'disabled' ? 'disabled' : 'regular'"
              (onClick)="editRow(idxLine)"
              [label]="'Edit'"
            ></u-button>
          } @else {
            @if (!(row.mode === 'newRow' && editingModelLength() === 1)) {
              <u-button [versionNumber]="2" [styleType]="'outlined'" (onClick)="cancelRow()" [label]="'Cancel'"></u-button>
            }
            @if (row.mode === 'newRow') {
              <u-button
                [versionNumber]="2"
                [styleType]="'outlined'"
                [stateElement]="disableSaveIndex() == idxLine ? 'disabled' : 'regular'"
                (onClick)="saveRow(idxLine)"
                [label]="'Save'"
              ></u-button>
            } @else {
              <u-button
                [versionNumber]="2"
                [styleType]="'outlined'"
                [stateElement]="disableSaveIndex() == idxLine ? 'disabled' : 'regular'"
                (onClick)="saveRow(idxLine)"
                [label]="'Update'"
              ></u-button>
            }
          }
        </div>
      }
    </div>
  }
</div>

@if (state() !== 'readonly') {
  <u-button
    class="add-button"
    [versionNumber]="2"
    [label]="addButtonText()"
    fontIcon="mac-maximize-plus"
    [styleType]="'text'"
    [typeElement]="'primary'"
    [stateElement]="disableAddButton() || editingModelLength() >= limit() || state() === 'disabled' ? 'disabled' : 'regular'"
    [sizeElement]="'large'"
    (onClick)="addButton()"
  ></u-button>
}
